import(/* webpackMode: "eager" */ "/vercel/path0/ui/src/app/stats/layout.tsx");
